import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { environment } from 'src/environments/environment';
import { LoggedInUserDto } from '../../core/interfaces/loggedInUserDto';
import { PageTitleService } from '../services/page-title.service';
import { LegalInfoService } from '../services/legal-info.service';
import { LoaderService } from '../loader/loader.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-contact-support',
    templateUrl: './contact-support.component.html',
    styleUrls: ['./contact-support.component.scss'],
    standalone: false
})

export class ContactSupportComponent implements OnInit {

  public headerText = 'Contact Support';
  public supportEmail: string;
  public supportEmailShow: string;
  public contactSupportContent: string;

  constructor(
    public pageTitleService: PageTitleService,
    private authenticationService: AuthenticationService,
    private legalInfoService: LegalInfoService,
    private loader: LoaderService
  ) {
  }

  ngOnInit() {
    const domainName = window.location.hostname;
    this.loader.show();
    this.legalInfoService.getLatestContactInfo(domainName).subscribe({
      next: (res: string) => {
      if (res) {
        this.contactSupportContent = res;
      }
      this.loader.hide();
    },
      error: (error: HttpErrorResponse) => {
        this.loader.hide();
      }
      });
    this.pageTitleService.title = this.headerText;
    this.supportEmailShow = environment.supportEmail;
    this.supportEmail = `mailto:${this.supportEmailShow}`;
  }

  public get claims() {
    return this.authenticationService.GetClaims();
  }
}
